module.exports = __webpack_public_path__ + "img/research_track.0eb93d4a.svg";